// Handle key plural options
export const isPlural = (count) => {
    return count > 1 ? 'other' : 'one';
};
